import React, {useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom'

import LogoWebSite from './LogoFooter';

function Footer() {

  const [displayPhone, setDisplayPhone] = useState(false);

  let phoneDisplay;

  const handleDisplayBtn = () => {
    setDisplayPhone(!displayPhone)
  }

  const btnDisplayPhone =
    <button className="text-xs mx-2 italic bg-gray-800 bg-opacity-25 rounded-sm py-1 px-5" onClick={handleDisplayBtn} > Afficher le numéro</button >

  if (displayPhone) {
    phoneDisplay = "+33 6 64 75 56 32"
  } else {
    phoneDisplay = "+33 6 64. .. .. .."  
  }

  return (
    <div className="w-full bg-header pattern2 border-t border-solid border-gray-800 border-opacity-25 mt-10 md:mt-32">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-3 gap-4 lg:flex w-full py-10">
          <div className="col-span-3 md:w-full lg:w-2/5">
            <LogoWebSite />
            <h3 className="text-white font-bold text-xl">Remote Monkey S.A.S.U</h3>
            <h2 className="text-sm mt-2 uppercase">Arnaud Desportes</h2>
            <h4 className="text-sm mb-2 uppercase">DEVELOPPEUR WEB FRONT-END FREELANCE</h4>
            <p className="hidden md:block text-xs">
              1553 route de saint-victor<br />
              38300 SUCCIEU<br />
              FRANCE
            </p>

            <div className="text-xs border-b border-solid border-gray-800 border-opacity-25 pb-2 mb-2"> Port. : {phoneDisplay} {!displayPhone ? btnDisplayPhone : <></>} </div>

            <div id="copyright" className="text-xs text-gray-700">
              <p>
                © 2020 developed with
                <span className="text-red-700" style={{ fontSize: '0.65rem', padding: '0 0.30rem' }}>
                  <FontAwesomeIcon icon="heart" />
                </span>
                by Remote Monkey S.A.S.U
              </p>
              <div id="stackProject">
                <p>
                  <span style={{ fontSize: '0.65rem', paddingRight: '0.40rem' }}>
                    <FontAwesomeIcon icon="layer-group" />
                  </span>
                Stack utilisé : React . Firebase . Tailwind</p>
              </div>
            </div>
          </div>
          <div className="hidden md:block col-span-3 md:col-span-1 lg:w2/6 lg:w-1/5 text-center md:text-left mt-8">
            <h4 className="text-white text-base font-bold mb-3">Société</h4>
            <div><Link to="/tarifs" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Tarifs</Link></div> 
            <div><Link to="/tarifs#faq" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">FAQ</Link></div> 
            <div><Link to="/contact" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Contact</Link></div>

            {/* <div><Link to="/test#" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Mentions légales</Link></div>  */}
            {/* <div><Link to="/test#" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Protection des données</Link></div>  */}
            {/* <div><Link to="/test#" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Plan du site</Link></div>  */}
            {/* <div><Link to="/test#" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pl-1 transition duration-300 ease-in-out ">Conditions générales</Link></div> */}
          </div>
          <div className="hidden md:inline-block col-span-3 md:col-span-1 lg:w2/6 lg:w-1/5 text-center md:text-center mt-8">
            <h4 className="text-white text-base font-bold mb-3">Navigation</h4>
            <div><Link to="/" className="px-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold transition duration-300 ease-in-out ">Accueil</Link></div>
            <div><Link to="/services" className="px-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold transition duration-300 ease-in-out ">Services</Link></div>
            <div><Link to="/portfolio" className="px-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold transition duration-300 ease-in-out ">Portfolio</Link></div>
            <div><Link to="/competences" className="px-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold transition duration-300 ease-in-out ">Compétences</Link></div>
            <div><Link to="/parcour" className="px-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold transition duration-300 ease-in-out ">Parcour</Link></div>
          </div>
          <div className="hidden md:block col-span-3 md:col-span-1 lg:w2/6 lg:w-1/5 text-center md:text-right mt-8">
            <h4 className="text-white text-base font-bold mb-3">Réseaux</h4>
            {/* <div><Link to="/testtest##" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">Facebook</Link></div> */}
            <div><a href="https://www.linkedin.com/in/arnaud-desportes-71999446/" target="_blank" rel="noopener noreferrer" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">Linkedin</a></div>
            {/* <div><Link to="/testtest##" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">WatsApp</Link></div> */}
            {/* <div><Link to="/testtest##" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">Discord</Link></div> */}
            <div><a href="https://github.com/Arnaud-Desportes/" target="_blank" rel="noopener noreferrer" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">GitHub</a></div>
            <div><a href="#/" className="p-5 text-xs hover:bg-indigo-600 block py-1 hover:text-white hover:font-semibold pr-1 transition duration-300 ease-in-out ">Malt</a></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;